import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Invoice } from '../../models/invoice';
import { BreadcrumbService } from '../../breadcrumb/breadcrumb.service';

@Component({
	selector: 'app-invoice-detail',
	templateUrl: 'invoice-detail.template.html'
})

/**
 * Component for the invoice detail page
 */
export class InvoiceDetailComponent implements OnInit
{
	invoice: Invoice;

	/**
	 * InvoiceDetailComponent constructor
	 *
	 * @param {ActivatedRoute} route
	 * @param {BreadcrumbService} breadcrumbService
	 */
	constructor(private route: ActivatedRoute, private breadcrumbService: BreadcrumbService)
	{
	  localStorage.setItem('keepSearchFilter', 'true');
	}

	/**
	 * Lifecycle hook that is called after data-bound properties of this component are
	 * initialized.
	 */
	ngOnInit()
	{
		this.route.data.subscribe(
			(data: { invoice: Invoice }) => {
				this.invoice = data.invoice;
			}
		);
	}

	/**
	 * Sets the currently selected invoice
	 *
	 * @param {Invoice} invoice
	 *
	 * @return void
	 */
	refreshInvoice(invoice: Invoice)
	{
		this.invoice = invoice;
	}
}



// WEBPACK FOOTER //
// ./src/app/invoices/invoice-detail/invoice-detail.component.ts